/** ActionBar — lays out a row of Button components. */
export function ActionBar(buttons) {
  const el = document.createElement("div");
  el.className = "actions";
  el.append(...buttons);
  return el;
}
